import {micromark} from "micromark";
import {gfm as gfmExtension, gfmHtml} from "micromark-extension-gfm";
import {twJoin} from "tailwind-merge";
import {
    NOTES_FEED_BODY_TEXT_STYLE,
    notesFeedBodyTruncateStyle,
} from "~/components/notes/notesPanelTypography";

const NOTE_PREVIEW_PROSE_CLASS =
    "min-w-0 w-full max-w-full break-words [overflow-wrap:anywhere]" +
    " [&_>*:first-child]:mt-0 [&_>*:last-child]:mb-0" +
    " [&_p]:my-0 [&_li]:my-0" +
    " [&_p]:leading-[var(--Line-Height-Body-M,20px)] [&_li]:leading-[var(--Line-Height-Body-M,20px)]" +
    " [&_p+p]:mt-ds-space-050 [&_li+_li]:mt-ds-space-050" +
    " [&_p]:text-inherit [&_li]:text-inherit [&_strong]:text-inherit [&_strong]:font-inherit" +
    " [&_em]:text-inherit [&_a]:text-inherit";

export function NoteMarkdownPreview({
    markdown,
    truncate = false,
}: {
    markdown: string;
    truncate?: boolean;
}) {
    if (markdown.trim() === "") {
        return null;
    }
    return (
        <div
            className={twJoin(NOTE_PREVIEW_PROSE_CLASS, truncate === true ? "min-w-0" : undefined)}
            style={truncate === true ? notesFeedBodyTruncateStyle() : NOTES_FEED_BODY_TEXT_STYLE}
            dangerouslySetInnerHTML={{
                __html: micromark(markdown, {
                    extensions: [gfmExtension()],
                    htmlExtensions: [gfmHtml()],
                    allowDangerousHtml: true,
                }),
            }}
        />
    );
}
